export const convertToLocalTime = (isoTimestamp) => {
  const date = new Date(isoTimestamp);

  const localTime = date.toLocaleString("en-GB", { timeZone: "Europe/London" });

  return localTime;
};

// Helper function to convert time to 12-hour format
export const convertTo12Hour = (time) => {
  const [hours, minutes] = time.split(":");
  const hourInt = parseInt(hours, 10);
  const isPM = hourInt >= 12;
  const formattedHour = (hourInt % 12 === 0 ? 12 : hourInt % 12)
    .toString()
    .padStart(2, "0");
  return `${formattedHour}:${minutes} ${isPM ? "PM" : "AM"}`;
};

// Helper function to convert time back to 24-hour format
export const convertTo24Hour = (time) => {
  const [timePart, period] = time.split(" ");
  let [hours, minutes] = timePart.split(":");
  hours = parseInt(hours, 10);

  if (period === "PM" && hours !== 12) {
    hours += 12;
  } else if (period === "AM" && hours === 12) {
    hours = 0;
  }

  return `${hours.toString().padStart(2, "0")}:${minutes}`;
};

// Utility to calculate time range filter based on option
export const getTimeFilter = (days) => {
  const now = new Date();
  return new Date(now.getTime() - days * 24 * 60 * 60 * 1000);
};
